import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  back: {
    id: 'views.ReturnToInvestors.back',
    defaultMessage: 'Powrót'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/ReturnToInvestors/ReturnToInvestors.intl.js